export default __webpack_public_path__ + "static/media/date-icon.86594402.svg";